import React, {useRef} from "react"
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button
} from "@chakra-ui/react"


type DeleteModalProps = {
    title: string,
    message: string,
    isOpen?: boolean,
    onDelete: () => void,
    onCancel: () => void
}

export function DeleteModal({isOpen, onDelete, onCancel, title, message}: DeleteModalProps) {
    const cancelRef = useRef()
    return <AlertDialog
        isOpen={isOpen}
        onClose={onCancel}
        leastDestructiveRef={cancelRef}
    >
        <AlertDialogOverlay>
            <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    {title}
                </AlertDialogHeader>

                <AlertDialogBody>
                    {message}
                </AlertDialogBody>
                <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button onClick={onDelete} colorScheme="red" ml={3}>
                        Delete
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialogOverlay>
    </AlertDialog>
}